import StudentDashboardClassroomPage from "./page"

export default StudentDashboardClassroomPage